import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NavbarLeft from "../Components/NavbarLeft";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
// import ReduceScenarioChoiceTable from "./components/ReduceScenarioChoiceTable";
import HistoryTable from "../AnalysisPage/components/HistoryTable";
import ComponentLoading from "../../commonComponents/ComponentLoading";

// REDUX
import { useDispatch, useSelector } from "react-redux";
import { fetchAnalysisHistory } from "../../redux/actions/analysisActions";

const ReduceScenarioChoice = () => {
  // REDUX ACTIONS
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const fetchAnalysisHistory_rd = () => dispatch(fetchAnalysisHistory());
  // REDUX STATES
  const analysis_history = useSelector((state) => (state.analysis.analysis_history ? state.analysis.analysis_history : null));

  useEffect(() => {
    async function fetch_fn(analysis_history) {
      // if (!analysis_history || (analysis_history && analysis_history.length == 0)) {
      setLoading(true);
      await fetchAnalysisHistory_rd();
      setLoading(false);
      // }
    }
    fetch_fn(analysis_history);
  }, []);

  return (
    <>
      <NavbarLeft currentPage={3} />
      <div className="w-full h-[70px] bg-white border-r-[1px] border-[#BEC4C] fixed z-10 flex items-center justify-start">
        <div className="w-full relative ml-[90px] flex justify-start items-center">
          <Link to="/Home">
            <BackArrow />
          </Link>
          <p className="font-Poppins-SemiBold text-lg relative p-10">Réduire - scénarios analysés</p>
        </div>
      </div>
      {/* <div className="mt-[70px] h-[747px] w-[1370px] flex items-center justify-center"> */}
      <div className="flex-row mt-[140px] items-center justify-center content-center">
        {/* <div className="w-[1030px] h-[610px] mb-[65px] ml-[100px]"> */}
        {/* <div> */}
        <p className="font-Poppins-SemiBold text-xl ml-[150px]">Sélectionnez un scénario à optimiser</p>

        {/* <div> */}
        {/* <ReduceScenarioChoiceTable/> */}
        {!loading && analysis_history ? (
          <HistoryTable navigate_to="ReduceParametersChoice" analysis_history={analysis_history} />
        ) : (
          <ComponentLoading height={35} style={"h-[400px] flex items-center justify-center"} />
        )}
        {/* </div> */}
      </div>
    </>
  );
};

export default ReduceScenarioChoice;
